import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AccountRepository } from '@timechef/features/account/state';

@Component({
  selector: 'app-carbonscore-modal',
  templateUrl: './carbonscore-modal.component.html',
  styleUrls: ['./carbonscore-modal.component.scss'],
  standalone: false,
})
export class CarbonscoreModalComponent {
  language$ = this.accountRepo.language$;

  constructor(
    private modalCtrl: ModalController,
    private accountRepo: AccountRepository,
  ) {}

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
